const sizeArray = ['small', 'medium', 'large', 'sm', 'md', 'lg'];

const sizeArrayReadOnly = ['small', 'medium', 'large', 'sm', 'md', 'lg'] as const;

export type FuelSize = typeof sizeArrayReadOnly[number];

export const fuelSizeArray: FuelSize[] = [...sizeArrayReadOnly]; // export typed arr

export const getFuelSize = (size?: string): FuelSize => {
    if (size && sizeArray.includes(size)) {
        // convert abberviation to full word
        if (size === 'sm') {
            return 'small';
        }

        if (size === 'md') {
            return 'medium';
        }

        if (size === 'lg') {
            return 'large';
        }

        return size as FuelSize;
    }

    return 'medium';
};

const inputVariantArray = ['outlined', 'elevated', 'filled'];

const inputVariantArrayReadOnly = ['outlined', 'elevated', 'filled'] as const;

export type FuelInputVariant = typeof inputVariantArrayReadOnly[number];

export const fuelInputVariantArray: FuelInputVariant[] = [...inputVariantArrayReadOnly]; // export typed arr

export const getFuelInputVariant = (variant?: string): FuelInputVariant => {
    if (variant && inputVariantArray.includes(variant)) {
        return variant as FuelInputVariant;
    }

    return 'outlined';
};

// /** updating global variant types */
declare module '@mui/material/InputBase' {
    interface InputBasePropsSizeOverrides {
        small: true;
        medium: true;
        large: true;
        sm: true;
        md: true;
        lg: true;
    }
}

declare module '@mui/material/IconButton' {
    interface IconButtonPropsSizeOverrides {
        small: true;
        medium: true;
        large: true;
        sm: true;
        md: true;
        lg: true;
    }
}

declare module '@mui/material/TextField' {
    interface TextFieldPropsSizeOverrides {
        small: true;
        medium: true;
        large: true;
        sm: true;
        md: true;
        lg: true;
    }
}

declare module '@mui/material/FormControl' {
    interface FormControlPropsSizeOverrides {
        small: true;
        medium: true;
        large: true;
        sm: true;
        md: true;
        lg: true;
    }
}

const feedbackTypeArray = ['success', 'error', 'warning', 'info'];

const feedbackTypeArrayReadOnly = ['success', 'error', 'warning', 'info'] as const;

export type FuelFeedbackType = typeof feedbackTypeArrayReadOnly[number];

export const fuelFeedbackTypeArray: FuelFeedbackType[] = [...feedbackTypeArrayReadOnly]; // export typed arr

export const getFuelFeedbackType = (feedbackType?: string, defaultType?: FuelFeedbackType): FuelFeedbackType => {
    if (feedbackType && feedbackTypeArray.includes(feedbackType)) {
        return feedbackType as FuelFeedbackType;
    }

    return defaultType || 'info';
};
